<template>
    <div :class="applyColor">
        {{ value }}
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

// Props
const props = defineProps({
    type: String,
    raw: [String, Number],
    value: [String, Number]
});

// Methods and Computed values

const shouldApplyColor = () => {
    const types = ['priceChange', 'percentChange', 'opinionSignal'];
    return types.includes(props.type);
};

const compareNumber = computed(() => {
    if (props.raw > 0) {
        return 'text-up';
    } else if (props.raw < 0) {
        return 'text-down';
    } else {
        return 'text-unch';
    }
});

const priceChange = ref(compareNumber.value);
const percentChange = ref(compareNumber.value);

const opinionSignal = computed(() => {
    if (props.value === 'Down') {
        return 'text-down';
    } else if (props.value === 'Up') {
        return 'text-up';
    } else {
        return 'text-unch';
    }
});

const applyColor = computed(() => {
    if (shouldApplyColor()) {
        return props.type === 'opinionSignal' ? opinionSignal.value : compareNumber.value;
    }
});
</script>
